import { render, staticRenderFns } from "./KnowledgeBase.vue?vue&type=template&id=6ce31f4f&scoped=true&"
import script from "./KnowledgeBase.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce31f4f",
  null
  
)

export default component.exports